import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from 'ng2-translate';

import { MapsModule } from '../maps/maps.module';
import { SharedModule } from '../shared/shared.module';

import { NewRouteComponent } from './new-route.component';

import { NewRouteService } from './services/new-route.service';

import { CreateFailedComponent } from './components/create-failed/create-failed.component';
import { CreateSuccessComponent } from './components/create-success/create-success.component';
import { CreateInProgressComponent } from './components/create-in-progress/create-in-progress.component';

import { KeysPipe } from './pipes/keys.pipe';

import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
import { SliderModule } from 'primeng/primeng';

@NgModule({
  imports: [
    SliderModule,
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SharedModule,
    NgxMyDatePickerModule,
    TranslateModule.forRoot()
  ],
  exports: [
    NewRouteComponent
  ],
  providers: [NewRouteService],
  declarations: [NewRouteComponent, CreateSuccessComponent, CreateFailedComponent, CreateInProgressComponent, KeysPipe]
})
export class NewRouteModule { }



// WEBPACK FOOTER //
// ./src/app/modules/new-route/new-route.module.ts